import { useRef, useState } from "react";
import { SmilePlus, Image as ImageIkon } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { EmojiVelger } from "./EmojiVelger";

export const GRADIENTER = [
  "linear-gradient(120deg, #14171c 0%, #2b4162 100%)",
  "linear-gradient(135deg, #0b3d2e 0%, #1f6f5c 55%, #7fb069 100%)",
  "linear-gradient(120deg, #3a1c1c 0%, #a24936 55%, #d9a05b 100%)",
  "linear-gradient(120deg, #1a2a3a 0%, #3e5c76 55%, #98b6c6 100%)",
  "linear-gradient(120deg, #14171c 0%, #6b5a2e 55%, #e3d84a 100%)",
  "linear-gradient(120deg, #e8e3d8 0%, #cfc5ae 100%)",
  "linear-gradient(120deg, #dfe6ec 0%, #aebfcd 100%)",
  "linear-gradient(120deg, #0d0f13 0%, #23272e 100%)",
  "linear-gradient(135deg, #4a1d1d 0%, #8a2f2f 100%)",
  "linear-gradient(120deg, #f3e9d2 0%, #e4b363 100%)",
];

const erBilde = (c) => c && !c.startsWith("linear-gradient");

export function DokIkonCover({ item, patch, docId }) {
  const [ikonVelger, setIkonVelger] = useState(false);
  const [coverVelger, setCoverVelger] = useState(false);
  const filRef = useRef(null);

  const lastOppCover = async (fil) => {
    if (!fil) return;
    const fd = new FormData();
    fd.append("fil", fil);
    try {
      const { data } = await api.post(`/admin/docs/${docId}/media`, fd);
      patch({ cover: data.url }, true);
      setCoverVelger(false);
    } catch { toast.error("Kunne ikke laste opp bildet"); }
  };

  return (
    <div className="dok-ikoncover" data-testid="dok-ikoncover">
      {item.cover && (
        <div
          className="dok-cover"
          style={erBilde(item.cover)
            ? { backgroundImage: `url(${item.cover})`, backgroundSize: "cover", backgroundPosition: "center" }
            : { background: item.cover }}
          data-testid="dok-cover"
        >
          <div className="dok-cover-knapper">
            <button type="button" onClick={() => setCoverVelger(true)} data-testid="dok-cover-endre">Endre cover</button>
            <button type="button" onClick={() => patch({ cover: "" }, true)} data-testid="dok-cover-fjern">Fjern</button>
          </div>
        </div>
      )}

      {item.icon && (
        <button
          type="button"
          onClick={() => setIkonVelger(true)}
          className={`dok-ikon ${item.cover ? "med-cover" : ""}`}
          title="Bytt ikon"
          data-testid="dok-ikon"
        >
          {item.icon}
        </button>
      )}

      {(!item.icon || !item.cover) && (
        <div className="dok-leggtil-rad" data-testid="dok-leggtil-rad">
          {!item.icon && (
            <button type="button" onClick={() => setIkonVelger(true)} data-testid="dok-leggtil-ikon">
              <SmilePlus size={12} /> Legg til ikon
            </button>
          )}
          {!item.cover && (
            <button type="button" onClick={() => setCoverVelger(true)} data-testid="dok-leggtil-cover">
              <ImageIkon size={12} /> Legg til cover
            </button>
          )}
        </div>
      )}

      {ikonVelger && (
        <EmojiVelger
          harIkon={!!item.icon}
          onVelg={(e) => { patch({ icon: e }, true); setIkonVelger(false); }}
          onFjern={() => { patch({ icon: "" }, true); setIkonVelger(false); }}
          onLukk={() => setIkonVelger(false)}
        />
      )}

      {coverVelger && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setCoverVelger(false)} />
          <div className="dok-cover-velger" data-testid="dok-cover-velger">
            <p className="dok-velger-tittel">Gradienter</p>
            <div className="dok-grad-grid">
              {GRADIENTER.map((g, i) => (
                <button key={g} type="button" style={{ background: g }}
                  onClick={() => { patch({ cover: g }, true); setCoverVelger(false); }}
                  data-testid={`dok-grad-${i}`} />
              ))}
            </div>
            <button type="button" className="dok-cover-opplast" onClick={() => filRef.current?.click()} data-testid="dok-cover-opplast">
              Last opp eget bilde …
            </button>
            <input ref={filRef} type="file" accept="image/png,image/jpeg,image/webp" className="hidden"
              onChange={(e) => { lastOppCover(e.target.files?.[0]); e.target.value = ""; }} data-testid="dok-cover-fil" />
          </div>
        </>
      )}
    </div>
  );
}
